module.exports = __webpack_public_path__ + "img/SurrealityCompound1.73b05b2d.png";